import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import PaintlessDentRemoval from "./pages/PaintlessDentRemoval";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import ServicePage from "./pages/ServicePage";
import { Toaster } from "./components/ui/toaster";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/paintless-dent-removal" element={<PaintlessDentRemoval />} />
            <Route path="/hail-damage-repair-sydney" element={<ServicePage slug="hail-damage-repair-sydney" />} />
            <Route path="/door-ding-repair-sydney" element={<ServicePage slug="door-ding-repair-sydney" />} />
            <Route path="/mobile-dent-repair-sydney" element={<ServicePage slug="mobile-dent-repair-sydney" />} />
            <Route path="/our-services" element={<Services />} />
            <Route path="/repairs-gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
